import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingBundleDTO } from "./useNormasTeachingBundleById.ts";

export function useDuplicateNormasTeachingBundle() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const duplicateNormasTeachingBundle = async (
    bundleId: string,
  ): Promise<NormasTeachingBundleDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingBundleDTO>(
          `/bundles/${bundleId}/duplicate`,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    duplicateNormasTeachingBundle,
    loading,
  };
}
